import React, { useState } from "react";
import Sidebar from "../commanComponents/Sidebar";
import Header from "../commanComponents/Header";
import BorderButton from "../commanComponents/buttons/BorderButton";
import { settingsNavData } from "../constants/utilities/NavTabsData";
import { useNavigate } from "react-router-dom";
import "./components.css";
import svgData from "../constants/utilities/svgData";

export default function SettingsWrapper({ children, active }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className={`mainLayoutWrapper ${isSidebarOpen ? "sidebar-open" : ""}`}>
      {isSidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
      <Sidebar active={active} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div className="mainLayoutRight">
        <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="mainContentArea">
          {children}
        </div>
      </div>
    </div>
  );
}
